export default function draftsReducer() {
  return {
    name: "drafts",
    initialState: {},
    stashForm(nextState, { formData }) {
      nextState[formData.guid] = formData;
    },
  };
}
